import http from "../utils/axios";
// 获取保司披露记录信息接口
export const getAgentInfo = data => {
  return http({
    url: "/api/agent/getAgentInfo", // 接口
    method: "post",
    data: data
  });
};
//添加、编辑披露信息记录分支机构接口
export const getAgentBranch = data => {
  return http({
    url: "/api/agent/getAgentBranch", // 接口
    method: "post",
    data: data
  });
};
//获取披露信息合作记录接口
export const getAgentCompany = data => {
  return http({
    url: "/api/agent/getAgentCompany", // 接口
    method: "post",
    data: data
  });
};
